import logo from './../assets/images/mdfl-nameplate.svg';

export default function NamePlate() {
    return (
        <img src={logo} className="img-fluid img-logo"  height="95" width="492" alt="Making Disciples for Life" />
    );
}
